import { render, staticRenderFns } from "./indexRepair.vue?vue&type=template&id=37c76adf&scoped=true"
import script from "./indexRepair.vue?vue&type=script&lang=js"
export * from "./indexRepair.vue?vue&type=script&lang=js"
import style0 from "./indexRepair.vue?vue&type=style&index=0&id=37c76adf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c76adf",
  null
  
)

export default component.exports